// extracted by mini-css-extract-plugin
export var btn = "v_mV r_r6 r_rK d_bx d_bM d_bB d_dt";
export var full = "v_s7 d_t d_F";